import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'button']

  copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback()
    }).catch((err) => {
      console.error('Failed to copy:', err)
    })
  }

  showFeedback() {
    if (!this.hasButtonTarget) return

    const originalText = this.buttonTarget.textContent
    this.buttonTarget.textContent = 'Copied!'
    this.buttonTarget.disabled = true

    setTimeout(() => {
      this.buttonTarget.textContent = originalText
      this.buttonTarget.disabled = false
    }, 2000)
  }
}
